const common = {
    welcome: "Welcome",
    logout: "Log out",
};
export default common;
